import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import PageTitle from 'components/global/PageTitle/PageTitle';
import SignalTable from 'components/global/SignalTable/SignalTable';
import SimpleCard from 'components/global/SimpleCard';
import FounderCreateRoomModal from 'components/views/FounderRooms/_components/FounderCreateRoomModal';
import FounderDeleteRoomModal from 'components/views/FounderRooms/_components/FounderDeleteRoomModal';
import FounderEditRoomModal from 'components/views/FounderRooms/_components/FounderEditRoomModal';
import FounderRoomRow from 'components/views/FounderRooms/_components/FounderRoomRow';
import { fetchAndSetRoomsData } from 'components/views/FounderRooms/_helpers/founderRooms.resolvers';
import withDismount from 'hocs/withDismount';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { $list } from 'signals/global.signals';
import { useEffectAsync } from 'utils/useEffectAsync';
import FounderPortfolioHighlights from './FounderPortfolioHighlights';

const FounderRooms = () => {
  useEffectAsync(fetchAndSetRoomsData);
  const navigate = useNavigate();
  return (
    <>
      <PageTitle
        Buttons={(
          <Button
            onClick={() => handleShowModal('founder-room-create')}
            className="bg-dark border-gray-900"
            size="sm"
          >
            <FontAwesomeIcon icon={faPlus} className="me-8" size="sm" />
            Add Room
          </Button>
        )}
      >
        Rooms
      </PageTitle>
      <SimpleCard>
        <FounderPortfolioHighlights />
        <SignalTable
          headers={[
            { key: 'name', value: 'Round Name' },
            { key: 'currentRaiseSize', value: 'Total Raise' },
            { key: 'amountCommitted', value: 'Committed' },
            { key: 'typeOfRaise', value: 'Type of Raise' },
            { key: 'investmentStage', value: 'Stage' },
            { key: 'viewCount', value: 'Views' },
            { key: 'visibility', value: 'Visibility' },
            { key: 'minimumInvestment', value: 'Min. Investment' },
            { key: 'Actions', value: 'Actions' },
          ]}
          rows={FounderRoomRow({ data: $list.value.data || [] })}
          onRowClick={(row) => navigate(`/founder/room/${row.id}`)}
        />
      </SimpleCard>
      <FounderCreateRoomModal />
      <FounderEditRoomModal />
      <FounderDeleteRoomModal />
    </>
  );
};

export default withDismount(FounderRooms);
